import { processPayrocPayment, savePayrocCard } from 'api/Transaction';

const isEmptyValue = (value) => value === undefined || value === null || value === '';

export const chargePayrocPaymentHandler = async (
  navigate,
  { surchargeAmount, methodDetail, appliedBalance, ...rest }
) => {
  const payload = {
    ...rest,
    surcharge: surchargeAmount,
    cardId: methodDetail,
    appliedBalance
  };

  const result = await processPayrocPayment(navigate, payload);

  if (result?.code !== 0) {
    const emptyKeys = ['amount', 'practiceId', 'terminalId'].filter((key) =>
      isEmptyValue(payload[key])
    );
    if (!payload.token && !payload.cardId) emptyKeys.push('paymentSource');
    const firstError = typeof result?.error === 'string' ? result.error : result?.error?.message;
    console.warn(
      `Payroc process_payment failed (code=${result?.code ?? 'n/a'}${
        emptyKeys.length ? `, emptyPayloadKeys=${emptyKeys.join(',')}` : ''
      })${firstError ? `: ${firstError}` : ''}`,
      { result, emptyKeys }
    );
  }

  return result;
};

export const saveCardHandler = (navigate, { ...rest }) => {
  return savePayrocCard(navigate, { ...rest });
};
